import { EMAIL } from "../../utils/regexLibrary";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import phone from "phone";
dayjs.extend(customParseFormat);
export function validateDOBFormat(value) {
    return dayjs(value, "MM/DD/YYYY", true).isValid();
}
export function validateDOBYears(value) {
    return dayjs().diff(dayjs(value, "MM/DD/YYYY", true), "year") >= 18;
}
export function validatePhone(value, opts) {
    if (opts === void 0) { opts = { required: true }; }
    if (!value)
        return !opts.required;
    var minLength = 14;
    return (typeof value === "string" &&
        (value === null || value === void 0 ? void 0 : value.length) >= minLength &&
        phone(value, { country: "USA" }).isValid);
}
function validateEmail(value) {
    if (!value)
        return false;
    return EMAIL.test(value);
}
export function validateUnlinkedPolicyHolderData(data) {
    var validDOB = validateDOBFormat(data.dateOfBirth) && validateDOBYears(data.dateOfBirth);
    return (Object.values(data).every(Boolean) &&
        validDOB &&
        validateEmail(data.email) &&
        validatePhone(data.phone));
}
